function showKSAPopup() {
    console.log('Showing KSA popup');
    if (!sessionStorage.getItem('popupShown')) {
        const popupHTML = `
            <div id="locationPopup">
                <h2>We are now live in KSA at oneshot.sa</h2>
                <div class="button-container">
                    <button class="ksa-button" onclick="window.location.href='https://oneshot.sa'">Visit KSA Site</button>
                    <button class="uae-button" onclick="closePopup()">Stay on UAE Site</button>
                </div>
            </div>
        `;
        document.body.insertAdjacentHTML('beforeend', popupHTML);
        console.log('Popup HTML inserted');
        sessionStorage.setItem('popupShown', 'true');
        console.log('Popup added to page');
    } else {
        console.log('Popup already shown this session');
    }
}

function closePopup() {
    console.log('Closing popup');
    document.getElementById('locationPopup').remove();
}

document.addEventListener("DOMContentLoaded", () => {
  console.log("DOM loaded, starting location check");
  checkVisitorLocation();
});

async function checkVisitorLocation() {
  console.log("Checking visitor location...");
  try {
    const response = await fetch("https://ipapi.co/json/");
    const data = await response.json();
    console.log("Location data:", data); // Log the full response

    if (data.country_code === "SA") {
      console.log("Visitor from Saudi Arabia detected");
      showKSAPopup();
    } else {
      console.log("Visitor not from SA, country:", data.country_code);
    }
  } catch (error) {
    console.error("Error checking location:", error);
  }
}

